import useComputedMenuItems from "./useComputedMenuItems";
import useIsNodeSelected from "./useIsNodeSelected";
import NodeDropPoints from "./NodeDropPoints";
import SelectedCover from './SelectedCover';
import { GridCellContext } from './Contexts';
import { useContext } from 'react';
import ContextMenuLayer from './ContextMenuLayer';

export default function NodeWrapper({node, nodeId,children}){

  let cellLocation = useContext(GridCellContext);
  let thisNodeIsSelected = useIsNodeSelected(nodeId)
  let {menuItems,onEvent} = useComputedMenuItems({nodeId,node,cellLocation,thisNodeIsSelected});

  return (
    <>
      {children}
      {thisNodeIsSelected && <SelectedCover nodeId={nodeId}/>}
      {false && <NodeDropPoints/>}
      {menuItems && <ContextMenuLayer onEvent={onEvent} items={menuItems}/>}
    </>
  )
}
